import React from 'react';
import ReportButton from '../../../../components/report/ReportButton';
import * as XLSX from 'xlsx';
import { useCompanyContext } from '../../../../context/CompanyContext';
import { useWatch } from 'react-hook-form';
import { BASE_PDF_STYLES } from '../../../../../utils/reportUtils';
import { excelCleanTable } from '../../../../../utils/excelUtils';
import { CLAIM_STATUS, ClaimFiltersOptions } from '../ClaimFilters';

type ClaimReportProps = {
  elementRef: React.MutableRefObject<HTMLElement | null>;
};

const ClaimReport = ({ elementRef }: ClaimReportProps) => {
  const { selectedCompany } = useCompanyContext();
  const filters = useWatch<ClaimFiltersOptions>();
  const reportDate = new Date();

  const excelElementPreProcess = (element: HTMLElement) => {
    excelCleanTable(element);

    return element;
  };

  const excelBeforeDownload = (workBook: XLSX.WorkBook) => {
    const sheet = workBook.Sheets['Sheet1'];
    const companyName = selectedCompany!.name;

    sheet['D2'] = { t: 's', v: companyName };
    sheet['D3'] = { t: 's', v: 'Claim Report' };
    sheet['A4'] = { t: 's', v: 'Search criteria:' };
    sheet['B5'] = { t: 's', v: 'Status:' };
    sheet['C5'] = {
      t: 's',
      v: CLAIM_STATUS.find((status) => status.value === filters.claimStatus)
        ?.label,
    };

    const rowStart = 6;
    sheet[`A${rowStart}`] = { t: 's', v: 'Created at:' };
    sheet[`B${rowStart}`] = { t: 's', v: reportDate.toLocaleString() };
  };

  return (
    <ReportButton
      elementToPrintRef={elementRef}
      fileName="Claim_Report"
      pdfStyles={BASE_PDF_STYLES}
      excelPreprocess={excelElementPreProcess}
      excelBeforeDownload={excelBeforeDownload}
      tableOriginCell="A8"
      widthElementID="claims-table"
    />
  );
};

export default ClaimReport;
